import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import styles from "./Card.module.scss";

export default function Card(props) {
  const {
    className,
    children,
    plain,
    profile,
    blog,
    raised,
    background,
    pricing,
    color,
    product,
    testimonial,
    ...rest
  } = props;
  const cardClasses = classNames(
    styles.card,
    {
      [styles.cardPlain]: plain,
      [styles.cardProfile]: profile || testimonial,
      [styles.cardBlog]: blog,
      [styles.cardRaised]: raised,
      [styles.cardBackground]: background,
      [styles.cardPricingColor]:
      (pricing && color !== undefined) || (pricing && background !== undefined),
      [styles[color]]: color,
      [styles.cardPricing]: pricing,
      [styles.cardProduct]: product,
    },
    className
  );
  return (
    <div className={cardClasses} {...rest}>
      {children}
    </div>
  );
}

Card.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  blog: PropTypes.bool,
  raised: PropTypes.bool,
  background: PropTypes.bool,
  pricing: PropTypes.bool,
  testimonial: PropTypes.bool,
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose"
  ]),
  product: PropTypes.bool,
  children: PropTypes.node
};
